import { render, staticRenderFns } from "./enterpriseDetail-yq.vue?vue&type=template&id=06d2d122&"
import script from "./enterpriseDetail-yq.vue?vue&type=script&lang=js&"
export * from "./enterpriseDetail-yq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports